import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-capture-main',
  templateUrl: './capture-main.component.html',
  styleUrls: ['./capture-main.component.css']
})
export class CaptureMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
